var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "page", attrs: { id: "profile_main", role: "main" } },
    [
      ["userCommunityPosts", "userCommunityLikes"].includes(_vm.$route.name)
        ? _c("section", { staticClass: "user-communities" }, [
            _c("div", { staticClass: "o-wrapper" }, [
              _c("div", { staticClass: "o-grid" }, [
                _c("div", { staticClass: "o-grid__item u-width-full" }, [
                  _c(
                    "div",
                    { staticClass: "user-communities__wrap" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "user-communities__back",
                          attrs: { href: "/u/" + _vm.$root.profile.username },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "9",
                                height: "15",
                                viewBox: "0 0 9 15",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M8 1L1 7.5L8 14",
                                  stroke: "black",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Back to " +
                                _vm._s(_vm.$root.profile.first_name) +
                                "'s communities"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-communities__images" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.$root.profile.avatar,
                            alt: "User pic",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "27",
                              height: "18",
                              viewBox: "0 0 27 18",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M26.0665 8.6986C25.9706 4.35236 22.2287 0.906582 17.7088 1.00193C16.1729 1.03443 14.7454 1.47255 13.5332 2.20622C15.8991 3.63708 17.4443 6.19528 17.3691 9.07571C17.2977 11.8145 15.7794 14.189 13.5351 15.5432C14.8432 16.3324 16.3969 16.7764 18.0565 16.7411C19.4383 16.712 20.7316 16.3539 21.8605 15.7484C23.5217 17.2044 25.7713 16.7377 25.7713 16.7377C24.8471 15.649 24.5958 14.3543 24.5532 13.4296C25.5398 12.0972 26.1056 10.459 26.0665 8.6986Z",
                                stroke: "black",
                                "stroke-width": "1.26469",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M9.6987 9.04459C9.63541 6.1752 11.1775 3.63142 13.5334 2.20607C12.3299 1.47792 10.9147 1.04072 9.39102 1.0027C4.87143 0.889879 1.11603 4.32155 1.00261 8.66749C0.956861 10.4279 1.51582 12.0679 2.49744 13.4043C2.45107 14.329 2.19477 15.6225 1.2661 16.7078C1.2661 16.7078 3.51415 17.1831 5.18099 15.7332C6.30736 16.343 7.59948 16.706 8.9812 16.7403C10.6524 16.782 12.2184 16.3381 13.5353 15.5431C11.2813 14.1834 9.75948 11.795 9.6987 9.04459Z",
                                stroke: "black",
                                "stroke-width": "1.26469",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M17.3697 9.07554C17.4449 6.19511 15.8997 3.63692 13.5338 2.20605C11.178 3.6314 9.63585 6.17519 9.69914 9.04457C9.75993 11.795 11.2817 14.1834 13.536 15.5431C15.78 14.1889 17.2986 11.8143 17.3697 9.07554Z",
                                stroke: "black",
                                "stroke-width": "1.26469",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: _vm.$root.community.image,
                            alt: _vm.$root.community.name,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("h1", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$root.profile.first_name) +
                            " in "
                        ),
                        _c(
                          "a",
                          { attrs: { href: "/" + _vm.$root.community.url } },
                          [_vm._v(_vm._s(_vm.$root.community.title))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.$root.profile.accredited_community ===
                      _vm.$root.community.id
                        ? _c(
                            "div",
                            { staticClass: "user-communities__accredited" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "23",
                                    viewBox: "0 0 24 23",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M13.0678 1.87572L12.6127 2.46668L13.0678 1.87572C12.4384 1.39102 11.5616 1.39102 10.9322 1.87572L9.45555 3.01297L9.81993 3.48609L9.45555 3.01297C9.40604 3.0511 9.34404 3.06931 9.28177 3.064L7.42469 2.90562C6.63319 2.83812 5.89551 3.3122 5.62811 4.06021L5.00072 5.81526C4.97968 5.87411 4.93737 5.92295 4.88211 5.95214L3.23421 6.82292C2.53187 7.19405 2.1676 7.99169 2.34705 8.76553L2.76811 10.5812C2.78223 10.642 2.77303 10.706 2.74233 10.7604L1.82681 12.3839L2.47756 12.7509L1.82681 12.3839C1.43661 13.0758 1.5614 13.9438 2.13074 14.4978L3.46656 15.7975C3.51135 15.8411 3.53819 15.8999 3.5418 15.9623L3.64932 17.823C3.69515 18.6161 4.26939 19.2788 5.04784 19.437L6.87431 19.8082C6.93556 19.8207 6.98992 19.8556 7.02668 19.9061L8.12312 21.4133C8.59042 22.0557 9.43178 22.3028 10.1722 22.015L11.9094 21.3398L11.6378 20.6408L11.9094 21.3398C11.9677 21.3172 12.0323 21.3172 12.0906 21.3398L12.3622 20.6408L12.0906 21.3398L13.8278 22.015C14.5682 22.3028 15.4096 22.0557 15.8769 21.4133L16.9733 19.9061C17.0101 19.8556 17.0644 19.8207 17.1257 19.8082L18.9522 19.437C19.7306 19.2788 20.3048 18.6161 20.3507 17.823L20.4582 15.9623C20.4618 15.8999 20.4887 15.8411 20.5334 15.7975L21.8693 14.4978C22.4386 13.9438 22.5634 13.0758 22.1732 12.3839L21.2577 10.7604C21.227 10.706 21.2178 10.642 21.2319 10.5812L21.6529 8.76553C21.8324 7.99169 21.4681 7.19405 20.7658 6.82292L19.1179 5.95214C19.0626 5.92295 19.0203 5.87411 18.9993 5.81526L18.3719 4.06021C18.1045 3.3122 17.3668 2.83812 16.5753 2.90562L14.7182 3.064C14.656 3.06931 14.594 3.0511 14.5444 3.01297L13.0678 1.87572Z",
                                      fill: "#DB2848",
                                      stroke: "#F3F3F3",
                                      "stroke-width": "1.5",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M9 11.7419L11.1538 14L15 9",
                                      stroke: "white",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v("Accredited writer")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-communities__stats" }, [
                        _c(
                          "div",
                          {
                            staticClass: "user-communities__stat",
                            on: { click: _vm.toggleFollowersMenu },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "19",
                                  height: "20",
                                  viewBox: "0 0 19 20",
                                  fill: "none",
                                },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "9.5",
                                    cy: "5.5",
                                    r: "4.75",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$root.stats.followers +
                                    " follower" +
                                    (_vm.$root.stats.followers !== 1
                                      ? +"s"
                                      : "")
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "user-communities__stat",
                            on: { click: _vm.toggleFollowingMenu },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "19",
                                  height: "20",
                                  viewBox: "0 0 19 20",
                                  fill: "none",
                                },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "9.5",
                                    cy: "5.5",
                                    r: "4.75",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$root.stats.following) + " following"
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "Menu",
                        {
                          attrs: {
                            "show-menu": _vm.showFollowersMenu,
                            "scroll-class": _vm.scrollClass,
                            "close-event": _vm.closeProfileFollowersMenuEvent,
                            top: true,
                          },
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "menu__title" }, [
                              _c("p", [_vm._v("Followers")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu__search" }, [
                              _c("div", { staticClass: "search" }, [
                                _c("input", {
                                  attrs: {
                                    type: "search",
                                    name: "search",
                                    id: "search",
                                    placeholder: "Search what you love...",
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu__items" }, [
                              _c("div", { staticClass: "following" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$cdn("/img2.0/avatar-example.png"),
                                    alt: "User pic",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "following__details" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(_vm.$root.profile.first_name) +
                                          " " +
                                          _vm._s(_vm.$root.profile.surname) +
                                          "\n                                                "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          "@" +
                                            _vm._s(_vm.$root.profile.username)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "following" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$cdn("/img2.0/avatar-example.png"),
                                    alt: "User pic",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "following__details" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(_vm.$root.profile.first_name) +
                                          " " +
                                          _vm._s(_vm.$root.profile.surname) +
                                          "\n                                                "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          "@" +
                                            _vm._s(_vm.$root.profile.username)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Menu",
                        {
                          attrs: {
                            "show-menu": _vm.showFollowingMenu,
                            "scroll-class": _vm.scrollClass,
                            "close-event": _vm.closeProfileFollowingMenuEvent,
                            top: true,
                          },
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "menu__title" }, [
                              _c("p", [_vm._v("Following")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu__search" }, [
                              _c("div", { staticClass: "search" }, [
                                _c("input", {
                                  attrs: {
                                    type: "search",
                                    name: "search",
                                    id: "search",
                                    placeholder: "Search what you love...",
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu__items" }, [
                              _c("div", { staticClass: "following" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$cdn("/img2.0/avatar-example.png"),
                                    alt: "User pic",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "following__details" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(_vm.$root.profile.first_name) +
                                          " " +
                                          _vm._s(_vm.$root.profile.surname) +
                                          "\n                                                "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          "@" +
                                            _vm._s(_vm.$root.profile.username)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "following__follow",
                                    attrs: { href: "#" },
                                  },
                                  [_c("p", [_vm._v("Follow")])]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "following" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$cdn("/img2.0/avatar-example.png"),
                                    alt: "User pic",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "following__details" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(_vm.$root.profile.first_name) +
                                          " " +
                                          _vm._s(_vm.$root.profile.surname) +
                                          "\n                                                "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          "@" +
                                            _vm._s(_vm.$root.profile.username)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "following__unfollow",
                                    attrs: { href: "#" },
                                  },
                                  [_c("p", [_vm._v("Unfollow")])]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-communities__links" }, [
                    _c(
                      "div",
                      { staticClass: "tabs u-m-b4 u-m-b0@s" },
                      [
                        _c("router-link", {
                          attrs: {
                            to:
                              "/u/" +
                              _vm.$root.profile.username +
                              "/" +
                              _vm.$root.community.url +
                              "/posts",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({
                                  href,
                                  route,
                                  navigate,
                                  isActive,
                                  isExactActive,
                                }) {
                                  return [
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: href },
                                          on: { click: navigate },
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              class: [
                                                !isExactActive && "inactive",
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Posts\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2383059083
                          ),
                        }),
                        _vm._v(" "),
                        _c("router-link", {
                          attrs: {
                            to:
                              "/u/" +
                              _vm.$root.profile.username +
                              "/" +
                              _vm.$root.community.url +
                              "/likes",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({
                                  href,
                                  route,
                                  navigate,
                                  isActive,
                                  isExactActive,
                                }) {
                                  return [
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: href },
                                          on: { click: navigate },
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              class: [
                                                !isExactActive && "inactive",
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Likes\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1736142040
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _c(
            "section",
            { staticClass: "profile" },
            [
              _c("div", { staticClass: "o-wrapper" }, [
                _c("div", { staticClass: "o-grid" }, [
                  _c("div", { staticClass: "o-grid__item u-width-full" }, [
                    _c("div", { staticClass: "profile__wrap" }, [
                      _c("div", { staticClass: "profile__details" }, [
                        _vm.$root.community !== false
                          ? _c("div", { staticClass: "profile__img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.$root.community.image,
                                  alt: _vm.$root.community.title,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "img",
                                _vm._b(
                                  {
                                    staticClass: "user",
                                    attrs: {
                                      width: "120",
                                      height: "120",
                                      alt:
                                        _vm.$root.profile.first_name +
                                        " " +
                                        _vm.$root.profile.surname,
                                    },
                                  },
                                  "img",
                                  _vm.avatarAttrs,
                                  false
                                )
                              ),
                            ])
                          : _c("div", { staticClass: "profile__img" }, [
                              _c(
                                "img",
                                _vm._b(
                                  {
                                    attrs: {
                                      width: "120",
                                      height: "120",
                                      alt:
                                        _vm.$root.profile.first_name +
                                        " " +
                                        _vm.$root.profile.surname,
                                    },
                                  },
                                  "img",
                                  _vm.avatarAttrs,
                                  false
                                )
                              ),
                            ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "profile__content" }, [
                          _c("div", { staticClass: "profile__content-user" }, [
                            this.$route.name !== "Drafts"
                              ? _c("h5", [
                                  _c("span", [
                                    _c("strong", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$root.profile.first_name +
                                            " " +
                                            _vm.$root.profile.surname
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _c("a", {
                                      attrs: {
                                        href:
                                          "/u/" + _vm.$root.profile.username,
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$root.profile.username !== ""
                                            ? "@" + _vm.$root.profile.username
                                            : ""
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$root.community !== false
                                    ? _c("span", { staticClass: "community" }, [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "/" + _vm.$root.community.url,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$root.community.title)
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$route.name === "Drafts"
                              ? _c(
                                  "h5",
                                  { staticClass: "u-hidden u-block@m" },
                                  [
                                    _c("span", [
                                      _c("strong", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$root.profile.first_name +
                                              " " +
                                              _vm.$root.profile.surname
                                          ),
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("a", {
                                        attrs: {
                                          href:
                                            "/u/" + _vm.$root.profile.username,
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$root.profile.username !== ""
                                              ? "@" + _vm.$root.profile.username
                                              : ""
                                          ),
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _vm.$root.community !== false
                                      ? _c("span", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/" + _vm.$root.community.url,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$root.community.title
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "profile__actions" },
                              [
                                _vm.$root.isOwnAccount
                                  ? [_vm._m(0)]
                                  : [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isFollowing === false,
                                              expression:
                                                "isFollowing === false",
                                            },
                                          ],
                                          staticClass: "button__follow",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.followUser(
                                                _vm.$root.profile.user_id
                                              )
                                            },
                                          },
                                        },
                                        [_c("p", [_vm._v("Follow")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isFollowing === true,
                                              expression:
                                                "isFollowing === true",
                                            },
                                          ],
                                          staticClass: "button__following",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.unfollowUser(
                                                _vm.$root.profile.user_id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "72",
                                                height: "32",
                                                viewBox: "0 0 72 32",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  width: "72",
                                                  height: "32",
                                                  rx: "16",
                                                  fill: "#47AAC0",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M37 23.6772C37.4017 22.1406 38.322 20.7725 39.6191 19.7837C40.9162 18.7948 42.5181 18.2401 44.1782 18.2049C45.8383 18.1697 47.4646 18.656 48.8064 19.5888C50.1483 20.5217 51.1314 21.8494 51.6044 23.3675",
                                                  stroke: "white",
                                                  "stroke-width": "1.5",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M44.6678 15.1797H43.9352C43.0173 15.1797 42.137 14.8319 41.4879 14.2129C40.8389 13.5938 40.4742 12.7543 40.4742 11.8788V11.5767C40.4742 10.6281 40.8693 9.71836 41.5726 9.04762C42.2759 8.37687 43.2297 8.00006 44.2243 8.00006C44.7377 7.99957 45.2462 8.09566 45.7206 8.28281C46.1951 8.46997 46.6262 8.74452 46.9892 9.09077C47.3522 9.43701 47.6401 9.84814 47.8364 10.3006C48.0326 10.7531 48.1333 11.2381 48.1328 11.7277V11.8788C48.1328 12.7543 47.7682 13.5938 47.1191 14.2129C46.47 14.8319 45.5897 15.1797 44.6718 15.1797H44.6678Z",
                                                  stroke: "white",
                                                  "stroke-width": "1.5",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M18 16.4839L22.3077 21L30 11",
                                                  stroke: "white",
                                                  "stroke-width": "1.5",
                                                  "stroke-linecap": "round",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card__menu",
                                    on: { click: _vm.toggleCommunitiesMenu },
                                  },
                                  [_vm._m(1)]
                                ),
                                _vm._v(" "),
                                _c(
                                  "Menu",
                                  {
                                    attrs: {
                                      "show-menu": _vm.showCommunitiesMenu,
                                      "close-event":
                                        _vm.closeProfileCommunitiesMenuEvent,
                                      top: true,
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "menu__links" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleFollowersMenu.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                        View followers\n                                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleFollowingMenu.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                        View following\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile__content-stats" }, [
                            _c("div", { class: ["profile__stat"] }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleFollowersMenu.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "33",
                                        height: "20",
                                        viewBox: "0 0 33 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "16.5",
                                          cy: "5.5",
                                          r: "4.75",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M8.44689 16.3762C9.78824 13.05 12.9034 10.75 16.5 10.75C20.0966 10.75 23.2118 13.05 24.5531 16.3762C24.8478 17.107 24.6742 17.7862 24.2018 18.3182C23.713 18.8686 22.9029 19.25 22 19.25H11C10.0971 19.25 9.287 18.8686 8.79822 18.3182C8.32581 17.7862 8.15219 17.107 8.44689 16.3762Z",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M11.9523 4.5C11.3173 3.02931 9.85397 2 8.15022 2C5.86405 2 4.01074 3.85331 4.01074 6.13947C4.01074 7.68807 4.86111 9.03805 6.12036 9.74794C6.72013 10.086 7.41264 10.2789 8.15022 10.2789C8.81468 10.2789 9.44257 10.1224 9.99902 9.84416C11.0462 9.32054 11.8404 8.36599 12.1491 7.21293",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M10.0569 9.79688C11.143 10.1125 12.1254 10.691 12.9385 11.4633M6.09593 9.84143C4.35884 10.3889 2.89938 11.6129 1.9936 13.2228C0.910334 15.1481 2.79086 17.0525 5 17.0525H8.35938",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M20.9871 4.5C21.6221 3.02931 23.0855 2 24.7892 2C27.0754 2 28.9287 3.85331 28.9287 6.13947C28.9287 7.68807 28.0783 9.03805 26.8191 9.74794C26.2193 10.086 25.5268 10.2789 24.7892 10.2789C24.1248 10.2789 23.4969 10.1224 22.9404 9.84416C21.8932 9.32054 21.0991 8.36599 20.7903 7.21293",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M22.8825 9.79688C21.7965 10.1125 20.814 10.691 20.001 11.4633M26.8435 9.84143C28.5806 10.3889 30.0401 11.6129 30.9459 13.2228C32.0291 15.1481 30.1486 17.0525 27.9395 17.0525H24.5801",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleFollowersMenu.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$root.stats.followers)),
                                  ]),
                                  _vm._v(
                                    "\n                                            Followers\n                                        "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { class: ["profile__stat"] }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleFollowingMenu.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "19",
                                        height: "20",
                                        viewBox: "0 0 19 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "9.5",
                                          cy: "5.5",
                                          r: "4.75",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleFollowingMenu.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.followingStats),
                                    },
                                  }),
                                  _vm._v(
                                    "\n                                            Following\n                                        "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "communitySearch",
                          staticClass: "profile__search",
                        },
                        [
                          _c("div", { staticClass: "search" }, [
                            _c(
                              "span",
                              {
                                class: [
                                  "search__icon",
                                  {
                                    "search__icon--loading": _vm.searchLoading,
                                  },
                                ],
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "search__icon-glass",
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "7",
                                        cy: "7",
                                        r: "5.5",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "11.5",
                                        y1: "11.5",
                                        x2: "15",
                                        y2: "15",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "svg",
                                  {
                                    staticClass: "search__icon-spinner",
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "7",
                                        cy: "7",
                                        r: "5.5",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-dasharray": "26 9",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchCommunity,
                                  expression: "searchCommunity",
                                },
                              ],
                              staticClass: "search",
                              attrs: {
                                type: "text",
                                placeholder: _vm.searchPlaceholder,
                              },
                              domProps: { value: _vm.searchCommunity },
                              on: {
                                keyup: _vm.getInput,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.searchCommunity = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: [
                                  "search__clear",
                                  _vm.searchActive ? "search__active" : "",
                                ],
                                attrs: { "aria-label": "Clear search" },
                                on: { click: _vm.clearInput },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 14 14",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M1 1L13 13M13 1L1 13",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile__links" }, [
                        _c(
                          "div",
                          { staticClass: "tabs u-m-b4 u-m-b0@s" },
                          [
                            _vm.$root.community === false
                              ? _c("router-link", {
                                  attrs: {
                                    to:
                                      "/u/" +
                                      _vm.$root.profile.username +
                                      (_vm.$root.community !== false
                                        ? "/" + _vm.$root.community.url
                                        : ""),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({
                                          href,
                                          route,
                                          navigate,
                                          isActive,
                                          isExactActive,
                                        }) {
                                          return [
                                            _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: href },
                                                  on: { click: navigate },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      class: [
                                                        !isExactActive &&
                                                          "inactive",
                                                      ],
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Communities\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    515349397
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("router-link", {
                              attrs: {
                                to:
                                  "/u/" +
                                  _vm.$root.profile.username +
                                  (_vm.$root.community !== false
                                    ? "/" + _vm.$root.community.url
                                    : "") +
                                  "/posts",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function ({
                                    href,
                                    route,
                                    navigate,
                                    isActive,
                                    isExactActive,
                                  }) {
                                    return [
                                      _c("div", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: href },
                                            on: { click: navigate },
                                          },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                class: [
                                                  !isExactActive &&
                                                    _vm.$route.name !==
                                                      "userDrafts" &&
                                                    "inactive",
                                                ],
                                              },
                                              [
                                                _vm.$root.isOwnAccount &&
                                                [
                                                  "userProfile",
                                                  "userPosts",
                                                  "userLikes",
                                                ].includes(_vm.$route.name)
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                                    Your posts\n                                                "
                                                      ),
                                                    ])
                                                  : _vm.$root.isOwnAccount &&
                                                    _vm.$route.name ===
                                                      "userDrafts"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                                    Your drafts\n                                                "
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "\n                                                    Posts\n                                                "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _vm.$root.isOwnAccount
                              ? _c("router-link", {
                                  attrs: {
                                    to:
                                      "/u/" +
                                      _vm.$root.profile.username +
                                      (_vm.$root.community !== false
                                        ? "/" + _vm.$root.community.url
                                        : "") +
                                      "/liked",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({
                                          href,
                                          route,
                                          navigate,
                                          isActive,
                                          isExactActive,
                                        }) {
                                          return [
                                            _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: href },
                                                  on: { click: navigate },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      class: [
                                                        !isExactActive &&
                                                          "inactive",
                                                      ],
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Liked posts\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    399390564
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$root.isOwnAccount
                              ? _c("router-link", {
                                  attrs: {
                                    to:
                                      "/u/" +
                                      _vm.$root.profile.username +
                                      "/reposts",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({
                                          href,
                                          route,
                                          navigate,
                                          isActive,
                                          isExactActive,
                                        }) {
                                          return [
                                            _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: href },
                                                  on: { click: navigate },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      class: [
                                                        !isExactActive &&
                                                          "inactive",
                                                      ],
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Reposts\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3117320796
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.$root.isOwnAccount &&
                    ["userPosts", "userDrafts"].includes(_vm.$route.name)
                      ? _c(
                          "div",
                          { staticClass: "profile__drafts" },
                          [
                            _vm.$route.name !== "userDrafts"
                              ? _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/u/" +
                                        _vm.$root.profile.username +
                                        "/drafts",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "View " +
                                        _vm._s(_vm.numDrafts) +
                                        " draft posts"
                                    ),
                                  ]
                                )
                              : _c(
                                  "router-link",
                                  { attrs: { to: "./posts" } },
                                  [
                                    _vm._v(
                                      "View " +
                                        _vm._s(_vm.numPosts) +
                                        " live posts"
                                    ),
                                  ]
                                ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "Menu",
                {
                  attrs: {
                    "show-menu": _vm.showFollowersMenu,
                    "scroll-class": _vm.scrollClass,
                    "close-event": _vm.closeProfileFollowersMenuEvent,
                    top: true,
                  },
                },
                [
                  _c("div", [
                    _c("div", { staticClass: "menu__title" }, [
                      _c("p", [_vm._v("Followers")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "menu__search followers" }, [
                      _c("div", { staticClass: "search" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchFollowers,
                              expression: "searchFollowers",
                            },
                          ],
                          staticClass: "search",
                          attrs: { type: "text", placeholder: "Search people" },
                          domProps: { value: _vm.searchFollowers },
                          on: {
                            keyup: _vm.getInput,
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchFollowers = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.showFollowersLoader
                          ? _c("img", {
                              staticClass:
                                "search__small-loader search__active",
                              attrs: {
                                src: _vm.$cdn(
                                  "/img/ui/icon-loader-eclipse.svg"
                                ),
                                alt: "loading",
                                width: "30",
                                height: "30",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                          class: [
                            "search__clear",
                            { search__active: _vm.searchActiveFollowers },
                          ],
                          attrs: {
                            src: _vm.$cdn("/img2.0/icons/close.svg"),
                            alt: "Remove text",
                          },
                          on: { click: _vm.clearInput },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "menu__items" },
                      _vm._l(_vm.followers, function (follower) {
                        return _c(
                          "a",
                          {
                            key: follower.id,
                            staticClass: "following",
                            attrs: { href: "/u/" + follower.username },
                          },
                          [
                            _c("img", {
                              staticClass: "c-avatar c-avatar--40",
                              attrs: {
                                src: follower.avatar,
                                alt: follower.name,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "following__details" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(follower.name) +
                                    "\n                                "
                                ),
                                _c("span", [
                                  _vm._v("@" + _vm._s(follower.username)),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "Menu",
                {
                  attrs: {
                    "show-menu": _vm.showFollowingMenu,
                    "scroll-class": _vm.scrollClass,
                    "close-event": _vm.closeProfileFollowingMenuEvent,
                    top: true,
                  },
                },
                [
                  _c("div", [
                    _c("div", { staticClass: "menu__title" }, [
                      _c("p", [_vm._v("Following")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "menu__search followings" }, [
                      _c("div", { staticClass: "search" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchFollowings,
                              expression: "searchFollowings",
                            },
                          ],
                          staticClass: "search",
                          attrs: { type: "text", placeholder: "Search people" },
                          domProps: { value: _vm.searchFollowings },
                          on: {
                            keyup: _vm.getInput,
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchFollowings = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.showFollowingsLoader
                          ? _c("img", {
                              staticClass:
                                "search__small-loader search__active",
                              attrs: {
                                src: _vm.$cdn(
                                  "/img/ui/icon-loader-eclipse.svg"
                                ),
                                alt: "loading",
                                width: "30",
                                height: "30",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                          class: [
                            "search__clear",
                            { search__active: _vm.searchActiveFollowings },
                          ],
                          attrs: {
                            src: _vm.$cdn("/img2.0/icons/close.svg"),
                            alt: "Remove text",
                          },
                          on: { click: _vm.clearInput },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "menu__items" },
                      _vm._l(_vm.followings, function (following, index) {
                        return _c(
                          "div",
                          { key: following.id, staticClass: "following" },
                          [
                            _c(
                              "a",
                              { attrs: { href: "/u/" + following.username } },
                              [
                                _c("img", {
                                  staticClass: "c-avatar c-avatar--40",
                                  attrs: {
                                    src: following.avatar,
                                    alt: following.name,
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "following__details",
                                attrs: { href: "/u/" + following.username },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(following.name) +
                                      "\n                                "
                                  ),
                                  _c("span", [
                                    _vm._v("@" + _vm._s(following.username)),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.$root.isOwnAccount
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "following__unfollow",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.unfollowIndexed(
                                          index,
                                          parseInt(following.id),
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [_c("p", [_vm._v("Unfollow")])]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _vm.privateMessage === false ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.privateMessage
        ? _c("div", { staticClass: "o-wrapper" }, [
            _c("div", { staticClass: "o-grid o-grid--center" }, [
              _c(
                "div",
                { staticClass: "o-grid__item u-width-7/12 u-width-full@l" },
                [
                  _c("div", { staticClass: "c-private" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.$cdn("/img/ui/icon-private.svg"),
                        alt: "Private Account",
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(2),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "button__edit", attrs: { href: "/settings" } },
      [_c("p", [_vm._v("Edit Profile")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dots" }, [
      _c("div", { staticClass: "dot" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h5", [_vm._v("This account is private")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                            Follow this user to see their communities and\n                            content\n                        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }